
export const matching = `
.matching-text {
  text-align: center;
  
  > div {
  
    > ul, > ol {
      display: inline-block;
      margin-left: 0px;
    }  
  }
}

.matchingPanel {
  p, li {
    line-height: 1.2em;
  }
}
`;
